import { Component, inject } from '@angular/core';
import { DATA_SELECTOR_INJECTION_TOKEN, LoadableStatus } from '@aiwyn/shared';
import { Store } from '@ngxs/store';
import { CommonClientRequestFactoryService, CommonClientRequestsState } from '@aiwyn/common/client-requests';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { ClientRequestsState } from '../../state';

@Component({
  selector: 'app-client-request-staff',
  templateUrl: './client-request-staff.component.html',
  styleUrls: ['./client-request-staff.component.scss'],
  providers: [
    {
      provide: DATA_SELECTOR_INJECTION_TOKEN,
      useValue: 'client-request-staff',
    },
  ],
  standalone: false,
})
export class ClientRequestStaffComponent {
  public dataSelector = inject(DATA_SELECTOR_INJECTION_TOKEN);
  
  allStaff$ = this.store.select(CommonClientRequestsState.getAllStaffLoadables).pipe(
    shareReplay(1),
  );

  relevantStaff$ = this.factoryService.getClientRequestGroups$(
    this.store.select(ClientRequestsState.getSlices.selectedGroupIdentity),
  ).pipe(
    switchMap(selectedGroup => selectedGroup ? selectedGroup.staff$ : this.allStaff$),
    // sort staff by name
    map(staff => [...staff ?? []].sort((a, b) => a.data?.name.localeCompare(b.data?.name))),
  );

  constructor(
    private readonly store: Store,
    private readonly factoryService: CommonClientRequestFactoryService,
  ) { }

  readonly LoadableStatus = LoadableStatus;
}
